import { all, fork } from "redux-saga/effects";
import sessionRequestWatcher from "store/session/saga";
import clientBasicDataRequestWatcher from "./clientBasicData/saga";

export default function* root() {
  yield all([fork(sessionRequestWatcher), fork(clientBasicDataRequestWatcher)]);
}
